import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=1d76bd6b&"
import script from "./js/orders.js?vue&type=script&lang=js&"
export * from "./js/orders.js?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports